export const GET_ALLHOTELS_REQUEST="GET_ALLHOTELS_REQUEST";
export const GET_ALLHOTELS_SUCCESS="GET_ALLHOTELS_SUCCESS";
export const GET_ALLHOTELS_FAILURE="GET_ALLHOTELS_FAILURE";
